import { useQuery } from "@tanstack/react-query";
import { analyzePerformance } from "@/utils/testAdaptivity";
import { TestResult } from "@/hooks/useTestResults";

export interface PerformanceMetrics {
  suggestions: string[];
  strengths: string[];
  weaknesses: string[];
}

export const usePerformanceMetrics = (childId: string, testResults: TestResult[] | undefined) => {
  return useQuery({
    queryKey: ["performanceMetrics", childId],
    queryFn: () => analyzePerformance(childId, testResults),
    enabled: !!childId && !!testResults,
  });
};